import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';

export interface ConfirmationData {
  header?: string;
  icon?: string;
  message?: Observable<string>;
  acceptIcon?: string;
  acceptLabel?: Observable<string>;
  rejectIcon?: string;
  rejectLabel?: Observable<string>;
  severity?: 'success' | 'info' | 'warn' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast';
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmService {
  private readonly _dialogService = inject(DialogService);
  private readonly _translateService = inject(TranslateService);

  public confirm(data?: ConfirmationData): Observable<boolean> {
    data ??= {} as ConfirmationData;
    // Dutch texts as keys: the backoffice shows them as they are, the portal translates them.
    data.header ??= this._translateService.instant('Bevestiging');
    data.icon = data?.icon ? `pi ${data.icon}` : 'pi pi-question';
    data.message ??= this._translateService.get('Weet je zeker dat je wilt doorgaan?');
    data.acceptIcon = data?.acceptIcon ? `pi ${data.acceptIcon}` : 'pi pi-check';
    data.acceptLabel ??= this._translateService.get('Ja');
    data.rejectIcon = data?.rejectIcon ? `pi ${data.rejectIcon}` : 'pi pi-times';
    data.rejectLabel ??= this._translateService.get('Nee');

    const dialogRef = this._dialogService.open(ConfirmationDialogComponent, {
      header: data.header,
      modal: true,
      maximizable: true,
      closable: true,
      data: data,
      resizable: true,
    });

    return dialogRef.onClose;
  }
}
